<abp-modal [(visible)]="open" (disappear)="close()" [busy]="isBusy()" [options]="{ size: 'lg' }">
  <ng-template #abpHeader>
    <h3>{{ 'SaasService::CloneTenant' | abpLocalization }}</h3>
  </ng-template>

  <ng-template #abpBody>
    @if (form) {
      <form [formGroup]="form" validateOnSubmit>
        <!-- Tenant Name -->
        <div class="mb-3">
          <label for="tenant-name" class="form-label">
            {{ 'SaasService::TenantName' | abpLocalization }}
            <span class="text-danger" title="This field is required">*</span>
          </label>
          <input
            type="text"
            id="tenant-name"
            class="form-control"
            formControlName="name"
            autofocus
          />
          <div abpValidationMessage="name"></div>
        </div>
        <!-- Tenant Admin's Email Address -->
        <div class="mb-3">
          <label for="admin-email" class="form-label">
            {{ 'SaasService::TenantAdminEmailAddress' | abpLocalization }}
            <span class="text-danger" title="This field is required">*</span>
          </label>
          <input
            type="email"
            id="admin-email"
            class="form-control"
            formControlName="adminEmailAddress"
          />
          <div abpValidationMessage="adminEmailAddress"></div>
        </div>
        <!-- Tenant Admin's Password -->
        <div class="mb-3">
          <label for="admin-password" class="form-label">
            {{ 'SaasService::TenantAdminPassword' | abpLocalization }}
            <span class="text-danger" title="This field is required">*</span>
          </label>
          <div class="input-group" validationTarget>
            <input
              id="admin-password"
              type="password"
              class="form-control"
              formControlName="adminPassword"
              autocomplete="new-password"
              [abpShowPassword]="visiblePasswords().adminPassword"
            />
            <button
              class="btn btn-secondary"
              type="button"
              (click)="togglePassword('adminPassword')"
            >
              <i
                class="fa"
                aria-hidden="true"
                [class.fa-eye-slash]="!visiblePasswords().adminPassword"
                [class.fa-eye]="visiblePasswords().adminPassword"
              ></i>
            </button>
          </div>
          <div abpValidationMessage="adminPassword"></div>
        </div>
        <!-- Confirm Admin Password -->
        <div class="mb-3">
          <label for="confirm-password" class="form-label">
            {{ 'SaasService::ConfirmAdminPassword' | abpLocalization }}
            <span class="text-danger" title="This field is required">*</span>
          </label>
          <div class="input-group" validationTarget>
            <input
              id="confirm-password"
              type="password"
              class="form-control"
              formControlName="confirmAdminPassword"
              autocomplete="new-password"
              [abpShowPassword]="visiblePasswords().confirmAdminPassword"
            />
            <button
              class="btn btn-secondary"
              type="button"
              (click)="togglePassword('confirmAdminPassword')"
            >
              <i
                class="fa"
                aria-hidden="true"
                [class.fa-eye-slash]="!visiblePasswords().confirmAdminPassword"
                [class.fa-eye]="visiblePasswords().confirmAdminPassword"
              ></i>
            </button>
          </div>
          <div abpValidationMessage="confirmAdminPassword"></div>
          @if (form.hasError('passwordMismatch') && form.get('confirmAdminPassword')?.dirty) {
            <div class="text-danger mt-1">{{ 'SaasService::PasswordsDoNotMatch' | abpLocalization }}</div>
          }
        </div>
        <!-- Tenant Activation State -->
        <div class="mb-3">
          <label for="activation-state" class="form-label">
            {{ 'SaasService::TenantActivationState' | abpLocalization }}
            <span class="text-danger" title="This field is required">*</span>
          </label>
          <select
            id="activation-state"
            class="form-control form-select"
            formControlName="activationState"
          >
            <option [ngValue]="0">{{ 'SaasService::Active' | abpLocalization }}</option>
            <option [ngValue]="2">{{ 'SaasService::Passive' | abpLocalization }}</option>
          </select>
          <div abpValidationMessage="activationState"></div>
        </div>
        <div formGroupName="extraProperties">
          <!-- Admin Username -->
          <div class="mb-3">
            <label for="admin-username" class="form-label">
              {{ 'SaasService::AdminUserName' | abpLocalization }}
              <span class="text-danger" title="This field is required">*</span>
            </label>
            <input
              type="text"
              id="admin-username"
              class="form-control"
              formControlName="AdminUserName"
            />
            <div abpValidationMessage="extraProperties.AdminUserName"></div>
          </div>
          <!-- Trade Name -->
          <div class="mb-3">
            <label for="trade-name" class="form-label">
              {{ 'SaasService::TradeName' | abpLocalization }}
              <span class="text-danger" title="This field is required">*</span>
            </label>
            <input type="text" id="trade-name" class="form-control" formControlName="TradeName" />
            <div abpValidationMessage="extraProperties.TradeName"></div>
          </div>
          <!-- Email -->
          <div class="mb-3">
            <label for="email" class="form-label">
              {{ 'SaasService::Email' | abpLocalization }}
              <span class="text-danger" title="This field is required">*</span>
            </label>
            <input type="email" id="email" class="form-control" formControlName="Email" />
            <div abpValidationMessage="extraProperties.Email"></div>
          </div>
          <!-- Company Asset Password -->
          <div class="mb-3">
            <label for="asset-password" class="form-label">
              {{ 'SaasService::AssetPassword' | abpLocalization }}
              <span class="text-danger" title="This field is required">*</span>
            </label>
            <div class="input-group" validationTarget>
              <input
                id="asset-password"
                type="password"
                class="form-control"
                formControlName="AssetPassword"
                autocomplete="new-password"
                [abpShowPassword]="visiblePasswords().AssetPassword"
              />
              <button
                class="btn btn-secondary"
                type="button"
                (click)="togglePassword('AssetPassword')"
              >
                <i
                  class="fa"
                  aria-hidden="true"
                  [class.fa-eye-slash]="!visiblePasswords().AssetPassword"
                  [class.fa-eye]="visiblePasswords().AssetPassword"
                ></i>
              </button>
            </div>
            <div abpValidationMessage="extraProperties.AssetPassword"></div>
          </div>
          <!-- Is Required -->
          <div class="mb-3">
            <div class="form-check">
              <input
                type="checkbox"
                id="is-required"
                class="form-check-input"
                formControlName="IsRequired"
              />
              <label for="is-required" class="form-check-label">
                {{ 'SaasService::IsRequired' | abpLocalization }}
                <span class="text-danger" title="This field is required">*</span>
              </label>
            </div>
            <div abpValidationMessage="extraProperties.IsRequired"></div>
          </div>
        </div>
      </form>
    }
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose (click)="close()">
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="save()"
      [disabled]="form?.invalid || isBusy()"
    >
      <i class="fa fa-check mr-1"></i>
      {{ 'AbpUi::Save' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
